import React, { FC, useEffect, useState } from 'react'
import styles from "../../assets/styles/layout.module.css"
import logo from "../../assets/images/layout/header/logo.png"
import { Link } from 'react-router-dom'
import { AppStoreIcon, DropdownWhiteIcon, FacebookIcon,LinkedInIcon, PlayStoreIcon, TwitterIcon } from '../../utils/functions/Icons'
import { Box, Input, Skeleton } from '@mui/material'
import PartnerImg1 from '../../assets/images/layout/footer/payment/1.svg'
import PartnerImg2 from '../../assets/images/layout/footer/payment/2.svg'
import PartnerImg3 from '../../assets/images/layout/footer/payment/3.svg'
import PartnerImg4 from '../../assets/images/layout/footer/payment/4.svg'
import PartnerImg5 from '../../assets/images/layout/footer/payment/5.svg'
import PartnerImg6 from '../../assets/images/layout/footer/payment/6.svg'
import PartnerImg7 from '../../assets/images/layout/footer/payment/7.svg'
import PartnerImg8 from '../../assets/images/layout/footer/payment/8.svg'
import whatsAppIcon from "../../assets/images/layout/footer/whatsapp.svg"
import { useSubscribeMutation } from '../../utils/store/myaccount/myAccountApi'
import { toast } from 'react-toastify'
import { getErrorMessage } from '../../utils/functions/functions'
import BtnLoader from '../common/BtnLoader'
import Image from '../common/Image'
interface props {
  primaryMenuData: PrimaryMenuCategory[] | undefined;
  isLoading: boolean
}
const Footer: FC<props> = ({ primaryMenuData, isLoading }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [email, setEmail] = useState("")
  const [fetchSubscribe, { isLoading: subscribeLoading }] = useSubscribeMutation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const scrollThreshold = 300;

    setIsVisible(scrollTop > scrollThreshold);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const result = await fetchSubscribe({ email_id: email })
    if (result?.data?.status === 200) {
      toast.success(result?.data?.message)
      setEmail("")
    }
    else {
      toast.error(getErrorMessage(result?.data?.message || result?.error));
    }
  }

  const handleRedirectWhatsApp = () => {
    window.open(
      `https://api.whatsapp.com/send/?phone=919625996301&text&type=phone_number&app_absent=0`
    );
  };
  return (
    <footer className={styles.footerMain}>
      <div className="container">
        <div className="grid md:grid-cols-5 grid-cols-1 md:gap-6 gap-10">
          <div className={`col-span-3 ${styles.footerLogoSection}`}>
            <div className={styles.footerLogo}>
              <Image src={logo} alt="logo" />
              <p>mCHEMIST offers its customers  <span>Authentic, Accessible and Affordable</span> services</p>
            </div>
            <div className="grid grid-cols-3 gap-6">
              <div className={styles.footerLinkcontentMain}>
                <div className={styles.footerLinkContentHeading}>
                  <h3>Company</h3>
                </div>
                <ul className={styles.footerLinksItemMain}>
                  <li>
                    <Link
                      to={"/pages/how-to-shop-on-mchemist"}
                    >
                      How to shop on mchemist
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={"/pages/what-is-mchemist"}
                    >
                      What is mchemist?
                    </Link>
                  </li>
                  <li>
                    <Link to={"/pages/about-us"}>
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link to={"/pages/contact-us"}>
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={"/pages/testimonials"}
                    >
                      Testimonials
                    </Link>
                  </li>
                </ul>
              </div>
              <div className={styles.footerLinkcontentMain}>
                <div className={styles.footerLinkContentHeading}>
                  <h3>All Categories</h3>
                </div>
                <ul className={styles.footerLinksItemMain}>
                  {isLoading ? Array.from({ length: 8 }).map((_, index) => <Box key={index} width={145} p={0.7} className="skeletonBox" >
                    <Skeleton variant="rectangular" width="100%" height={15} className="skeletonStyle" />
                  </Box>)
                    :
                    primaryMenuData?.map((item, index) => {
                      return (
                        <li key={index}>
                          <Link to={item?.cat_url}>{item?.medicine_category}</Link>
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
              <div className={styles.footerLinkcontentMain}>
                <div className={styles.footerLinkContentHeading}>
                  <h3>Our Policies</h3>
                </div>
                <ul className={styles.footerLinksItemMain}>
                  <li>
                    <Link to={"/pages/terms-and-conditions"}>
                      Terms and Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to={"/pages/privacy-policy"}>Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to={"/pages/returns-refunds"}>Returns & Refunds</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className={`col-span-2 ${styles.footerNewsLatterSection}`}>
            <div className={styles.FooterRightAlignCenterMain}>
              <div className={styles.FooterRightAlignCenter}>
                <div className={styles.DownloadAppIcons}>
                  <PlayStoreIcon onClick={() => window.open(`https://play.google.com/store/apps/details?id=com.mChemist&pcampaignid=web_share`)} />
                  <AppStoreIcon onClick={() => window.open(`https://apps.apple.com/in/app/mchemist/id6581481317`)} />
                </div>
                <form className={styles.subscribeSection} onSubmit={handleSubscribe}>
                  <div className={styles.subscribeTitle}>
                    <h3>Subscribe here to avail new offers </h3>
                  </div>
                  <div className={styles.subscribeInputAndBtn}>
                    <Input
                      name='email'
                      type='email'
                      placeholder='Enter your email address'
                      className='customInput subscribeInput'
                      value={email}
                      required
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <button disabled={subscribeLoading} className='fillButton subscribeBtn'> {subscribeLoading && <BtnLoader />} Subscribe</button>
                  </div>
                </form>
                <div className={styles.borderDivider}></div>
                <div className={styles.socialIconsMain}>
                  <div className={styles.socialIcons}>
                    <a
                      href="https://www.facebook.com/mchemistindia"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Facebook"
                    >
                      <FacebookIcon />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/mchemist-com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="LinkedIn"
                    >
                      <LinkedInIcon />
                    </a>
                    <a
                      href="https://twitter.com/mChemistindia"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Twitter"
                    >
                      <TwitterIcon />
                    </a>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.PaymentPartners}>
          <div className={styles.PaymentPartnersHeading}>
            <h3>Payment Partners</h3>
          </div>
          <div className={styles.partnersImg}>
            <Image src={PartnerImg1} alt="PartnerImg1" />
            <Image src={PartnerImg2} alt="PartnerImg2" />
            <Image src={PartnerImg3} alt="PartnerImg3" />
            <Image src={PartnerImg4} alt="PartnerImg4" />
            <Image src={PartnerImg5} alt="PartnerImg5" />
            <Image src={PartnerImg6} alt="PartnerImg6" />
            <Image src={PartnerImg7} alt="PartnerImg7" />
            <Image src={PartnerImg8} alt="PartnerImg8" />
          </div>
        </div>
        <div className={styles.copyRightAndNote}>
          <h3>We do not sell medicines without a valid prescription.   We do not dispense Schedule X, Schedule H1 Medicines, Antibiotics and Psychotropic Substances . For sale in India only.</h3>
          <p>Copyright © {new Date().getFullYear()} mChemist All Rights Reserved.</p>
        </div>
      </div>
      <div className={styles.whatsAppFixedMain}>
        <div className={styles.whatsAppFixed} onClick={handleRedirectWhatsApp}>
          <div className={styles.OrderOnWhatsapp}>
            <p>Order on WhatsApp</p>
          </div>
          <Image src={whatsAppIcon} alt="whatsAppIcon" />
        </div>
      </div>
      {
        isVisible &&
        <div className={styles.ScrollToTopMain}>
          <div className={styles.ScrollToTopBox} onClick={scrollToTop}>
            <DropdownWhiteIcon />
          </div>
        </div>
      }
    </footer>
  )
}

export default Footer